export enum ExtensionApiName {
  extract = 'extract',
  embellish = 'embellish',
  extractRequest = 'extractRequest',
  root = 'root'
}
